export default __webpack_public_path__ + "static/media/cat-mil.df6a8754.jpg";